import { PlatformType } from '@okletsplay/core';
import { modalsSelectorFactory } from 'app/store/modal/selectors';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dialog } from 'shared/components/Dialog';
import { DialogName, Route } from 'app/enums';
import { Box, Button, Typography } from '@mui/material';
import { useStyles } from './PlatformLinkingDialog.styles';
import { modalsReducers } from 'app/store/modal/slice';
import { useDispatch, useSelector } from 'react-redux';
import { LinkingProviderFormat } from 'modules/platform-linking/components/Format';

export const PlatformLinkingDialog: FC = () => {
  const platformType: PlatformType = useSelector(
    modalsSelectorFactory.useModalPayload(DialogName.PlatformLink)
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { classes } = useStyles();

  const onCloseHandler = (): void => {
    dispatch(modalsReducers.closeModal(DialogName.PlatformLink));
  };

  const acceptHandler = (): void => {
    dispatch(modalsReducers.closeModal(DialogName.PlatformLink));
    navigate(Route.PlatformLinking);
  };

  return (
    <Dialog
      maxWidth="sm"
      contentHeight={150}
      name={DialogName.PlatformLink}
      actions={
        <>
          <Button
            fullWidth
            size="medium"
            color="error"
            variant="outlined"
            className={classes.cancelButton}
            onClick={onCloseHandler}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            size="medium"
            color="primary"
            variant="contained"
            onClick={acceptHandler}
          >
            Link
          </Button>
        </>
      }
    >
      <Box className={classes.root}>
        <Typography className={classes.title}>Add game account</Typography>
        <Typography>
          Add <LinkingProviderFormat platformType={platformType} /> account to enable functionality.
        </Typography>
      </Box>
    </Dialog>
  );
};
